import { render, staticRenderFns } from "./Expohallariel.vue?vue&type=template&id=afc6e88c&scoped=true&"
import script from "./Expohallariel.vue?vue&type=script&lang=js&"
export * from "./Expohallariel.vue?vue&type=script&lang=js&"
import style0 from "./Expohallariel.vue?vue&type=style&index=0&scope=true&lang=css&"
import style1 from "./Expohallariel.vue?vue&type=style&index=1&id=afc6e88c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc6e88c",
  null
  
)

export default component.exports